import axios from "axios";
import { HOST_URL } from "./Host";

export const SET_TICKET_TYPES = "SET_TICKET_TYPES";
export const SET_USER_TICKETS = "SET_USER_TICKETS";
export const SET_OPERATOR_TICKETS = "SET_OPERATOR_TICKETS";
export const SET_ADMIN_TICKETS = "SET_ADMIN_TICKETS";
export const SET_OPERATOR_ALL_SERVICES_TICKETS =
  "SET_OPERATOR_ALL_SERVICES_TICKETS";
export const SET_ADMIN_ALL_SERVICES_TICKETS = "SET_ADMIN_ALL_SERVICES_TICKETS";

const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
  "X-Accept-Version": "2.0",
};

export function setTicketTypes(ticketTypes) {
  return {
    type: SET_TICKET_TYPES,
    payload: ticketTypes,
  };
}

export function setUserTickets(userTickets) {
  return {
    type: SET_USER_TICKETS,
    payload: userTickets,
  };
}

export function setOperatorTickets(operatorTickets) {
  return {
    type: SET_OPERATOR_TICKETS,
    payload: operatorTickets,
  };
}

export function setAdminTickets(adminTickets) {
  return {
    type: SET_ADMIN_TICKETS,
    payload: adminTickets,
  };
}

export function setOperatorAllServicesTickets(operatorAllServicesTickets) {
  return {
    type: SET_OPERATOR_ALL_SERVICES_TICKETS,
    payload: operatorAllServicesTickets,
  };
}

export function setAdminAllServicesTickets(adminAllServicesTickets) {
  return {
    type: SET_ADMIN_ALL_SERVICES_TICKETS,
    payload: adminAllServicesTickets,
  };
}

export function getTicketTypes() {
  return async (dispatch) => {
    try {
      const response = await axios.get(`${HOST_URL}/reclamation-types`, {
        headers: {
          ...headers,
        },
      });

      await dispatch(setTicketTypes(response.data.data));
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      console.log(errorMessage);
    }
  };
}

export function createUserTickets(token, data, service, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${HOST_URL}/tickets`, data, {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      });
      await dispatch(getUserTickets(token, data.company, service));
      callback({
        success: true,
        message: response.data.message,
        data: response.data.data,
      });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function createOperatorTickets(token, data, service, country, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${HOST_URL}/tickets`, data, {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      });
      await dispatch(getOperatorTickets(token, service, country));
      callback({
        success: true,
        message: response.data.message,
        data: response.data.data,
      });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function getUserTickets(token, company, service) {
  return async (dispatch) => {
    try {
      const response = await axios.get(
        `${HOST_URL}/tickets?company=${company}&service=${service}`,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await dispatch(setUserTickets(response.data.data));
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      console.log(errorMessage);
    }
  };
}

export function getOperatorTickets(token, service, country) {
  return async (dispatch) => {
    try {
      const response = await axios.get(
        `${HOST_URL}/tickets?service=${service}&country=${country}`,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await dispatch(setOperatorTickets(response.data.data));
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      console.log(errorMessage);
    }
  };
}

export function getAdminTickets(token, service) {
  return async (dispatch) => {
    try {
      const response = await axios.get(
        `${HOST_URL}/tickets?service=${service}`,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await dispatch(setAdminTickets(response.data.data));
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      console.log(errorMessage);
    }
  };
}

export function getOperatorAllServicesTickets(token, country) {
  return async (dispatch) => {
    try {
      const response = await axios.get(
        `${HOST_URL}/tickets?country=${country}`,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await dispatch(setOperatorAllServicesTickets(response.data.data));
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      console.log(errorMessage);
    }
  };
}

export function getAdminAllServicesTickets(token) {
  return async (dispatch) => {
    try {
      const response = await axios.get(`${HOST_URL}/tickets`, {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      });

      await dispatch(setAdminAllServicesTickets(response.data.data));
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      console.log(errorMessage);
    }
  };
}

export function getOperatorOdooTickets(token, reclamationCode, country) {
  return async (dispatch) => {
    try {
      const response = await axios.get(
        `${HOST_URL}/tickets?reclamationCode=${reclamationCode}&country=${country}`,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await dispatch(setOperatorTickets(response.data.data));
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      console.log(errorMessage);
    }
  };
}

export function getAdminOdooTickets(token, reclamationCode) {
  return async (dispatch) => {
    try {
      const response = await axios.get(
        `${HOST_URL}/tickets?reclamationCode=${reclamationCode}`,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await dispatch(setAdminTickets(response.data.data));
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      console.log(errorMessage);
    }
  };
}

export function assignTicket(token, data, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `${HOST_URL}/tickets/actions/assign`,
        data,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      //   await dispatch(setProcedures(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function closeTicket(token, data, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `${HOST_URL}/tickets/actions/terminate`,
        data,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      //   await dispatch(setProcedures(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function rejectTicket(token, data, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${HOST_URL}/tickets/reject`, data, {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      });

      //   await dispatch(setProcedures(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}
